var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { navigate, Registration } from '@teliaee/crm-components';
import { Container } from 'telia-front-react';
import { observer } from 'mobx-react';
import React, { Component } from 'react';
import { injectStores } from '../util/StoresUtil';
import Config from '../Config';
let RegistrationPage = class RegistrationPage extends Component {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "ssoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "translateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    componentDidMount() {
        if (this.ssoStore.customerId && !this.ssoStore.isPrivateCustomer) {
            navigate('/');
        }
    }
    render() {
        return (React.createElement(Container, null,
            React.createElement(Registration, { currentLanguage: this.translateStore.currentLanguage, redirectUrl: "/konto", onNoRegistrableEntities: () => window.location.assign(Config.diilCrmUrl) })));
    }
};
RegistrationPage = __decorate([
    injectStores,
    observer
], RegistrationPage);
export default RegistrationPage;
